import http from 'hub-http/clients/apiClient';
import { fromRPC } from 'pulse/adapters';
import { createRpcClientV2 } from 'rpc-client-utils';
import { listConversationsRpc } from '../../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineConversationsService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const listConversationsResolver = fromRPC({
  rpc: listConversationsRpc,
  rpcClient
});
export const fetchConversations = request => {
  return rpcClient.call(listConversationsRpc, {
    request
  });
};